"use strict";
import React, {Component} from "react";
import {PropTypes} from "Subschema";
import axios from "axios";
import styleContent from "!!raw!./Terms.cssraw";
/**
 * This will not work correctly unless it is served from a paypal.com domain.
 *
 * localhost.paypal.com is good enough.
 *
 */
export default class Terms extends Component {

    static propTypes = {
        url: PropTypes.expression,
        busyMessage: PropTypes.content,
        styleClass: PropTypes.style
    };
    static injectedProps = {
        url: "/us/webapps/mpp/bmltermsmini",
        busyMessage: "Loading Terms and Conditions...",
        styleClass: "Terms"

    };

    state = {
        errorCount: 0
    };

    componentDidMount() {
        this.mounted = true;
        this.requestContent();
    }

    requestContent() {
        axios.get(this.props.url).then(this.handleContent, this.handleError);
    }

    handleContent = (response) => {
        const doc = this.refs.iframe.contentWindow.document.open();
        doc.write(response.data);
        const style = doc.createElement('style');
        style.innerHTML = styleContent;
        doc.head.appendChild(style);
        doc.close();

    };

    handleError = (error) => {
        this.setState({errorCount: this.state.errorCount++});
    };

    render() {
        const rest = {};
        //fallback to iframe iso morphically
        if (!this.mounted) {
            rest.src = this.props.url;
        }

        return <iframe className={this.props.iframeClass}   ref="iframe" {...rest}>
        </iframe>
    }
}


/** WEBPACK FOOTER **
 ** ./src/types/credit/Terms.jsx
 **/